import React from 'react';

import {Select, Input, Textarea} from 'Components/Form';

/*
Example...
<Travel
    value={form.travel}
    error={getFieldError('travel')}
    onChange={(v) => handleInput('travel', v)}
/>
*/

export default class Travel extends React.Component {
    /**
     * @var options
     * @type {array}
     */
    options = [
        {
            label: 'Train',
            value: 'Train'
        },
        {
            label: 'Hire Car',
            value: 'Hire Car'
        },
        {
            label: 'Own Car',
            value: 'Own Car'
        },
        {
            label: 'Plane',
            value: 'Plane'
        },
        {
            label: 'Other',
            value: 'Other'
        }
    ];

    /**
     * @method handleChange
     * @param {string} key
     * @param {string} v
     */
    handleChange = (key, v) =>  {
        const {value, onChange} = this.props;

        onChange({
            ...value,
            [key]: v
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            value,
            error
        } = this.props;

        return (
            <div className='bg-gray-200 p-4 flex flex-col gap-4'>
                <Select
                    label="Please confirm how the individual will be travelling to the event?"
                    value={value?.travel}
                    error={error}
                    onChange={(v) => this.handleChange('travel', v)}
                    options={this.options}
                />

                {value?.travel === 'Train' &&
                    <>
                        <Input
                            label="Departure station"
                            value={value?.departure_station}
                            onChange={(v) => this.handleChange('departure_station', v)}
                        />

                        <Input
                            label="Time of train"
                            value={value?.time_of_train}
                            onChange={(v) => this.handleChange('time_of_train', v)}
                        />

                        <Input
                            label="Return station"
                            value={value?.return_station}
                            onChange={(v) => this.handleChange('return_station', v)}
                        />
                    </>
                }

                {value?.travel === 'Hire Car' &&
                    <>
                        <Input
                            label="Address where car should be dropped off"
                            value={value?.where_car_drop_off}
                            onChange={(v) => this.handleChange('where_car_drop_off', v)}
                        />

                        <Input
                            label="When car should be dropped off"
                            value={value?.when_car_drop_off}
                            onChange={(v) => this.handleChange('when_car_drop_off', v)}
                        />

                        <Input
                            label="Address where car will be picked up"
                            value={value?.where_car_pick_up}
                            onChange={(v) => this.handleChange('where_car_pick_up', v)}
                        />

                        <Input
                            label="When car should be picked up"
                            value={value?.when_car_pick_up}
                            onChange={(v) => this.handleChange('when_car_pick_up', v)}
                        />
                    </>
                }

                {value?.travel === 'Plane' &&
                    <>
                        <Input
                            label="Departure airport"
                            value={value?.departure_airport}
                            onChange={(v) => this.handleChange('departure_airport', v)}
                        />

                        <Input
                            label="Flight time"
                            value={value?.flight_time}
                            onChange={(v) => this.handleChange('flight_time', v)}
                        />

                        <Input
                            label="Name as on passport"
                            value={value?.passport_name}
                            onChange={(v) => this.handleChange('passport_name', v)}
                        />
                    </>
                }

                {value?.travel === 'Other' &&
                    <Textarea
                        label="Specify"
                        value={value?.specify}
                        onChange={(v) => this.handleChange('specify', v)}
                    />
                }
            </div>
        );
    }
}